module.exports = __webpack_public_path__ + "img/help_delete_book01.5b0e0d24.png";